import { Navigate } from "react-router-dom";

import { useDesignVersion } from "../DesignVersionContext";
import DashboardV2 from "./DashboardV2";

const Dashboard = () => {
    const { version } = useDesignVersion();

    if (version !== "v2") return <Navigate to="/" replace />;

    return <DashboardV2 />;
};

export default Dashboard;
